"use client";

import React, { useState } from "react";
import { ControlCombobox, ControlsProvider, ControlOption } from "../components/ui/ControlCombobox";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";

export default function ControlComboboxExample() {
  const [selectedControls, setSelectedControls] = useState<string[]>([]);
  
  const handleControlSelect = (controlValue: string) => {
    console.log("Control selected:", controlValue);
  };
  
  const handleControlDeSelect = (controlValue: string) => {
    console.log("Control deselected:", controlValue);
  };
  
  const handleAllSelect = () => {
    console.log("All controls selected");
  };
  
  const handleAllDeselect = () => {
    console.log("All controls deselected");
  };
  
  return (
      <div className="p-6 max-w-3xl mx-auto">
        <Card className="mb-8">
          <CardHeader>
            <CardTitle>Control Selector</CardTitle>
            <CardDescription>
              Select controls from various compliance frameworks
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ControlCombobox
              selected={selectedControls}
              setSelected={setSelectedControls}
              placeholder="Search and select controls..."
              onControlSelect={handleControlSelect}
              onControlDeSelect={handleControlDeSelect}
              onAllSelect={handleAllSelect}
              onAllDeselect={handleAllDeselect}
            />
          </CardContent>
        </Card>

        {selectedControls.length > 0 && (
          <Card>
            <CardHeader>
              <CardTitle>Selected Controls</CardTitle>
              <CardDescription>
                {selectedControls.length} control{selectedControls.length !== 1 ? 's' : ''} selected
              </CardDescription>
            </CardHeader>
            <CardContent>
              <pre className="bg-secondary/50 p-4 rounded-md overflow-auto">
                {JSON.stringify(selectedControls, null, 2)}
              </pre>
            </CardContent>
          </Card>
        )}
      </div>
  );
}
